


















import Vue from 'vue';

import { AvisoSnackbarOptions } from '../../../back/src/types';

export default Vue.extend({
  name: 'AvisoSnackbar',
  props: {
    value: {
      type: Boolean,
    },
    options: {
      type: Object as () => AvisoSnackbarOptions,
    },
  },
  data: () => ({
    show: false,
  }),
  watch: {
    value() {
      this.show = this.value;
    },
  },
});
